import { createContext } from "react";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { AddPaymentOptions } from "./types";

export type PaymentControllerContextType = {
  tenderedAmountInput: string;
  validTenderedAmount: boolean;
  isRefundAmount: boolean;
  tenderedAmountAsInteger: number | undefined;
  setTenderedAmountInput: (value: string) => void;
  addPayment: (
    paymentMethod: PaymentMethod,
    options?: AddPaymentOptions
  ) => Promise<void>;
};

export const PaymentControllerContext = createContext<
  PaymentControllerContextType | undefined
>(undefined);
